import { FormControlLabel, Switch, SwitchProps } from '@mui/material'
import { useController } from 'react-hook-form'

interface FormSwitchProps extends Omit<SwitchProps, 'name' | 'value' | 'defaultValue' | 'checked' | 'onChange'> {
  name: string
  label: string
  defaultValue?: boolean
  onValueChange?: (checked: boolean) => void
}

export const FormSwitch: React.FC<FormSwitchProps> = ({
  name,
  label,
  defaultValue = false,
  onValueChange,
  ...switchProps
}) => {
  const { field } = useController({ name, defaultValue })

  const handleChange = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    field.onChange(checked)
    onValueChange?.(checked)
  }

  return (
    <FormControlLabel
      control={<Switch checked={field.value ?? false} onChange={handleChange} {...switchProps} />}
      label={label}
      sx={{ paddingX: 1 }}
    />
  )
}
